<script>
import {
    layoutComputed
} from "@/state/helpers";
import Horizontal from "./horizontal";
import SearchableSelect from "@/components/SearchableSelect";

export default {
    components: {
        Horizontal,
        SearchableSelect,
    },
    data() {
        return {
            showScrollTop: false,
            reminders: [],
            reminderOpen: false,
            reminderUsers: [],
            written: [],
            reminderSaved: '',
            reminderSaving: false,
            reminderTab: 'mine',
            reminderForm: { user_id: '', body: '', visible_until: '' },
        };
    },
    computed: {
        ...layoutComputed,
        isAdmin() {
            try {
                const u = JSON.parse(localStorage.getItem('userdata') || '{}');
                return u.role_name === 'admin';
            } catch (e) {
                return false;
            }
        },
    },
    mounted() {
        window.addEventListener('scroll', this.onScrollTopToggle, { passive: true });
        this.onScrollTopToggle();
        this.loadReminders();
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.onScrollTopToggle);
    },
    methods: {
        onScrollTopToggle() {
            const y = window.scrollY || document.documentElement.scrollTop || 0;
            this.showScrollTop = y > 280;
        },
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        loadReminders() {
            this.$http.get('/users/reminders').then(res => {
                this.reminders = res.data || [];
            }).catch(() => { this.reminders = []; });
        },
        toggleReminder() {
            this.reminderOpen = !this.reminderOpen;
            this.reminderSaved = '';
            if (!this.reminderOpen) return;
            this.loadReminders();
            if (this.isAdmin) this.loadWritten();
        },
        openWriteTab() {
            this.reminderTab = 'write';
            if (this.reminderUsers.length) return;
            this.$http.post('/users', { params: { per_page: 200 } }).then(res => {
                this.reminderUsers = res.data.data || res.data || [];
            }).catch(() => { this.reminderUsers = []; });
        },
        loadWritten() {
            this.$http.get('/users/reminders/mine').then(res => {
                this.written = res.data || [];
            }).catch(() => { this.written = []; });
        },
        saveReminder() {
            if (this.reminderSaving) return;
            if (!this.reminderForm.user_id || !this.reminderForm.body || !this.reminderForm.visible_until) return;
            this.reminderSaving = true;
            this.reminderSaved = '';
            this.$http.post('/users/reminders', this.reminderForm).then(() => {
                this.reminderForm = { user_id: '', body: '', visible_until: '' };
                this.reminderSaved = 'Kaydedildi';
                this.reminderTab = 'written';
                this.loadWritten();
            }).finally(() => { this.reminderSaving = false; });
        },
        deleteReminder(id) {
            this.$http.delete('/users/reminders/' + id).then(() => this.loadWritten());
        },
    },
};
</script>

<template>
<div>
    <Horizontal v-if="layoutType === 'horizontal'" :layout="layoutType">
        <slot />
    </Horizontal>

    <button v-if="isAdmin || reminders.length" type="button" class="reminder-write" @click="toggleReminder">
      Görev
      <span v-if="reminders.length">{{ reminders.length }}</span>
    </button>
    <div v-if="reminderOpen" class="reminder-drawer">
      <div class="reminder-drawer__head">
        <strong>Görevler</strong>
        <button type="button" @click="toggleReminder">&times;</button>
      </div>
      <div class="reminder-tabs">
        <button type="button" :class="{ active: reminderTab === 'mine' }" @click="reminderTab = 'mine'">Görevlerim</button>
        <button v-if="isAdmin" type="button" :class="{ active: reminderTab === 'write' }" @click="openWriteTab">Görev yaz</button>
        <button v-if="isAdmin" type="button" :class="{ active: reminderTab === 'written' }" @click="reminderTab = 'written'">Yazdıklarım</button>
      </div>
      <div v-if="reminderTab === 'mine'" class="reminder-list">
        <div v-if="!reminders.length" class="reminder-empty">Görev yok</div>
        <div v-for="item in reminders" :key="item.id" class="reminder-alert">
          <span>{{ item.body }}</span>
          <small>{{ item.author || 'Sistem' }} · {{ (item.visible_until || '').slice(0, 16).replace('T', ' ') }}</small>
        </div>
      </div>
      <template v-else-if="reminderTab === 'write'">
        <SearchableSelect
          v-model="reminderForm.user_id"
          :options="reminderUsers"
          label="name"
          :reduceFn="o => o.id"
          placeholder="Kullanıcı ara..."
          searchable
        />
        <input v-model="reminderForm.body" maxlength="500" placeholder="Görev veya hatırlatma">
        <input v-model="reminderForm.visible_until" type="datetime-local">
        <button type="button" class="reminder-save" :disabled="reminderSaving" @click="saveReminder">
          <i v-if="reminderSaving" class="bx bx-loader-alt bx-spin"></i>
          {{ reminderSaving ? 'Kaydediliyor' : 'Yaz' }}
        </button>
        <p v-if="reminderSaved" class="reminder-ok">{{ reminderSaved }}</p>
      </template>
      <div v-else-if="reminderTab === 'written'" class="reminder-list">
        <div v-if="!written.length" class="reminder-empty">Yazdığın görev yok</div>
        <div v-for="item in written" :key="'w' + item.id" class="reminder-item">
          <div>
            <span>{{ item.body }}</span>
            <small>{{ item.user_name }} · {{ (item.visible_until || '').slice(0, 16).replace('T', ' ') }}</small>
          </div>
          <button type="button" class="reminder-del" @click="deleteReminder(item.id)">Sil</button>
        </div>
      </div>
    </div>

    <button
      v-show="showScrollTop"
      type="button"
      class="scroll-top-btn"
      title="Yukarı çık"
      @click="scrollToTop"
    >
      <i class="bx bx-up-arrow-alt"></i>
    </button>
</div>
</template>

<style scoped>
.reminder-write {
  position: fixed;
  right: 24px;
  bottom: 84px;
  z-index: 1050;
  border: 0;
  background: #0f172a;
  color: #fff;
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}
.reminder-write span {
  margin-left: 6px;
  background: #f97316;
  border-radius: 999px;
  padding: 0 6px;
}
.reminder-tabs { display: flex; flex-wrap: wrap; gap: 6px; }
.reminder-tabs button {
  border: 0;
  background: #f1f5f9;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}
.reminder-tabs button.active { background: #0f172a; color: #fff; }
.reminder-alert {
  padding: 10px 12px;
  border-radius: 12px;
  background: #fff7ed;
  color: #9a3412;
  font-size: 13px;
  font-weight: 600;
}
.reminder-alert small { display: block; margin-top: 2px; font-weight: 500; color: #c2410c; }
.reminder-empty { color: #64748b; font-size: 13px; }
.reminder-drawer {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1060;
  width: 340px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  background: #fff;
  box-shadow: -8px 0 24px rgba(15, 23, 42, 0.12);
}
.reminder-drawer__head { display: flex; justify-content: space-between; align-items: center; }
.reminder-drawer__head button {
  border: 0;
  background: transparent;
  font-weight: 700;
  cursor: pointer;
}
.reminder-drawer input {
  width: 100%;
  height: 34px;
  border: 0;
  border-radius: 8px;
  background: #f8fafc;
  padding: 0 8px;
}
.reminder-save {
  height: 36px;
  border: 0;
  border-radius: 8px;
  background: #0f172a;
  color: #fff;
  font-weight: 700;
  cursor: pointer;
}
.reminder-save:disabled { opacity: 0.7; cursor: wait; }
.reminder-ok { margin: 0; color: #15803d; font-size: 13px; font-weight: 700; }
.reminder-list { overflow: auto; display: flex; flex-direction: column; gap: 8px; margin-top: 8px; }
.reminder-item {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 10px;
  background: #f8fafc;
  font-size: 13px;
  font-weight: 600;
}
.reminder-del {
  border: 0;
  background: transparent;
  color: #b91c1c;
  font-weight: 700;
  cursor: pointer;
}
.reminder-item small { display: block; font-weight: 500; color: #64748b; }
.scroll-top-btn {
  position: fixed;
  right: 24px;
  bottom: 28px;
  z-index: 1050;
  width: 44px;
  height: 44px;
  border: 0;
  border-radius: 50%;
  background: #2563eb;
  color: #fff;
  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.35);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.15s ease, background 0.15s ease;
}

.scroll-top-btn i {
  font-size: 1.45rem;
  line-height: 1;
}

.scroll-top-btn:hover {
  background: #1d4ed8;
  transform: translateY(-2px);
}
</style>
